import { Hooks } from '@/apilib';

export const hooks = {
  undoWasPerformed: Hooks.createHook<{
    originParams: any;
    targetParams: any;
  }>(),
  redoWasPerformed: Hooks.createHook<{
    originParams: any;
    targetParams: any;
  }>(),
};
